import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/private/pagination";

const Users = () => {
  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filter, setFilter] = useState({
    searchQuery: "",
    searchBy: "document",
    stateFilter: "all",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // MODAL
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newRole, setNewRole] = useState("");

  // AREAS
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

useEffect(() => {
  if (!token) return;

  const loadData = async () => {
    setLoading(true);

    const usersData = await authFetch(ENDPOINTS.getUsers);
    if (usersData.success) setUsers(usersData.users);
    else setUsers([]);

    // Cargar áreas
    const areasData = await authFetch(ENDPOINTS.getarea);

    if (areasData.success) {
      setAreas(Array.isArray(areasData.data) ? areasData.data : []);
    } else {
      setAreas([]);
    }

    setLoading(false);
  };

  loadData();
}, [token, authFetch]);

  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
    setCurrentPage(1);
  };

  const handleSearch = () => {
    const query = filter.searchQuery.toLowerCase();

    let result = users.filter((user) => {
      switch (filter.searchBy) {
        case "document":
          return user.IdDocumento.includes(query);
        case "name":
          return (user.first_name + " " + user.last_name)
            .toLowerCase()
            .includes(query);
        case "role":
          return user.role.toLowerCase().includes(query);
        default:
          return false;
      }
    });

    if (filter.stateFilter !== "all") {
      result = result.filter((u) => String(u.state) === filter.stateFilter);
    }

    return result;
  };

  const filteredUsers = handleSearch();

  const totalPages = Math.ceil(filteredUsers.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentUsers = filteredUsers.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ───────────── MODAL ─────────────
  const openModal = (action, user) => {
    setModalAction(action);
    setSelectedUser(user);

    if (action === "changeRole") {
      setNewRole(user.role);
      setSelectedArea(user.area);
    }

    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedUser(null);
    setModalAction(null);
  };

  const handleConfirmAction = async () => {
    if (!selectedUser || !modalAction) return;

    try {
      // RESET PASSWORD
      if (modalAction === "reset") {
        const res = await authFetch(
          `${ENDPOINTS.resetPassword}?id=${selectedUser.IdDocumento}`,
          { method: "PUT" }
        );

        alert(res.success ? "Contraseña restablecida." : res.message);
      }

      // TOGGLE STATE
      if (modalAction === "toggle") {
        const newState = selectedUser.state === 1 ? 0 : 1;

        const res = await authFetch(
          `${ENDPOINTS.changeState}?id=${selectedUser.IdDocumento}`,
          {
            method: "PUT",
            body: JSON.stringify({ state: newState }),
          }
        );

        if (res.success) {
          setUsers((prev) =>
            prev.map((u) =>
              u.IdDocumento === selectedUser.IdDocumento
                ? { ...u, state: newState }
                : u
            )
          );
          alert("Estado actualizado.");
        } else alert(res.message);
      }

      // CHANGE ROLE
    if (modalAction === "changeRole") {

  if (!newRole || !selectedArea) {
    alert("Debe seleccionar rol y área.");
    return;
  }

  const res = await authFetch(
    `${ENDPOINTS.changerole}?id=${selectedUser.IdDocumento}`,
    {
      method: "PUT",
      body: JSON.stringify({
        role: newRole,
        id_area: selectedArea
      }),
    }
  );

  if (res.success) {
    setUsers((prev) =>
      prev.map((u) =>
        u.IdDocumento === selectedUser.IdDocumento
          ? { ...u, role: newRole, id_area: selectedArea }
          : u
      )
    );

    alert("Rol y área actualizados correctamente.");
  } else {
    alert(res.message);
  }
}
    } catch (error) {
      alert("Error con el servidor.");
    }

    closeModal();
  };

  if (loading) return <p>Cargando usuarios...</p>;

  return (
    <div className="container mt-4 p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Lista de Usuarios</h2>
        <button
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/user/createUser")}
        >
          <i className="bi bi-person-plus-fill me-1"></i> Crear Usuario
        </button>
      </div>

      {/* Filtros */}
      <div className="row mb-3">
        <div className="col-md-4">
          <label className="m-1">Buscar por nombre, documento o rol</label>
          <input
            type="text"
            name="searchQuery"
            className="form-control"
            value={filter.searchQuery}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-4">
          <label className="m-1">Tipo de búsqueda:</label>
          <select
            className="form-select"
            name="searchBy"
            value={filter.searchBy}
            onChange={handleFilterChange}
          >
            <option value="document">Documento</option>
            <option value="name">Nombre</option>
            <option value="role">Rol</option>
          </select>
        </div>

        {/* ⬇ Nuevo filtro por estado */}
        <div className="col-md-4">
          <label className="m-1">Estado:</label>
          <select
            className="form-select"
            name="stateFilter"
            value={filter.stateFilter}
            onChange={handleFilterChange}
          >
            <option value="all">Todos</option>
            <option value="1">Activos</option>
            <option value="0">Inactivos</option>
          </select>
        </div>
      </div>
      {/* TABLA */}
      {currentUsers.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>Documento</th>
                <th>Rol</th>
                <th>Nombre</th>
                <th>Apellido</th>
                <th>Email</th>
                <th>Estado</th>
                <th style={{ width: "380px" }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((user) => (
                <tr key={user.IdDocumento}>
                  <td>{user.IdDocumento}</td>
                  <td>{user.role}</td>
                  <td>{user.first_name}</td>
                  <td>{user.last_name}</td>
                  <td>{user.email}</td>
                  <td>{Number(user.state) === 1 ? "Activo" : "Inactivo"}</td>
                  <td>
                    <button
                      className="btn btn-secondary btn-sm me-2"
                      onClick={() => openModal("reset", user)}
                    >
                      <i className="bi bi-arrow-repeat me-1"></i>Restablecer
                    </button>

                    <button
                      className="btn btn-dark btn-sm me-2"
                      onClick={() => openModal("changeRole", user)}
                    >
                      <i className="bi bi-person-gear me-1"></i>Cambiar rol
                    </button>

                    <button
                      className={`btn btn-sm ${
                        Number(user.state) === 1
                          ? "btn-outline-pink"
                          : "btn-outline-purple"
                      }`}
                      onClick={() => openModal("toggle", user)}
                    >
                      <i className="bi bi-power me-1"></i>
                      {Number(user.state) === 1 ? "Desactivar" : "Activar"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay usuarios registrados.</p>
      )}

      {/* MODAL */}
      {showModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={closeModal}
          ></div>

          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalAction === "reset"
                      ? "Restablecer Contraseña"
                      : modalAction === "toggle"
                      ? "Cambiar Estado"
                      : "Cambiar Rol"}
                  </h5>
                  <button className="btn-close" onClick={closeModal}></button>
                </div>

                <div className="modal-body">
                  {modalAction === "reset" && (
                    <p>
                      ¿Deseas restablecer la contraseña del usuario{" "}
                      {selectedUser.first_name} {selectedUser.last_name}?
                    </p>
                  )}

                  {modalAction === "toggle" && (
                    <p>
                      ¿Deseas cambiar el estado del usuario{" "}
                      {selectedUser.first_name} {selectedUser.last_name}?
                    </p>
                  )}

                  {modalAction === "changeRole" && (
                    <>
                      <p>
                        Cambiar rol del usuario{" "}
                        <strong>
                          {selectedUser.first_name}{" "}
                          {selectedUser.last_name}
                        </strong>
                      </p>

                      <select
                        className="form-select mt-2"
                        value={newRole}
                        onChange={(e) => setNewRole(e.target.value)}
                      >
                        <option value="SuperAdmin">SuperAdmin</option>
                        <option value="Coordinador">Coordinador</option>
                        <option value="Auditor">Auditor</option>
                        <option value="Apoyo">Apoyo</option>
                        <option value="Sst">Sst</option>
                        <option value="Empleado">Empleado</option>
                        <option value="Externo">Externo</option>
                        <option value="Comunicaciones">Comunicaciones</option>
                      </select>
                      
                      <select
                        className="form-select mt-3"
                        value={selectedArea ?? ""}
                        onChange={(e) => setSelectedArea(e.target.value)}
                      >
                        <option value="">Seleccione un área</option>

                        {areas.map((area) => (
                          <option key={area.id_area} value={String(area.id_area)}>
                            {area.name}
                          </option>
                        ))}
                      </select>
                    </>
                  )}
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button
                    className="btn btn-outline-pink"
                    onClick={handleConfirmAction}
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Users;